<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <div class="save-panel">
      <button class="btn  btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ 'save' | setText('Сохранить') }}
      </button>
    </div>
  </div>
</template>
<script>
import { cardUpdate, cardContent, pushLang } from "@/plugins/functions";
import {setJobPosition} from '@/_api/api3';
export default {
  data: () => ({
    cardLink: "business/customers",
    cardSetLink: "business/customers",
    item: null,
    fields: [
      {
        key: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
        readonly: false,
      },
      {
        key: "is_moderated",
        label: "Активен",
        type: "checkbox",
      },
      {
        col: 'col-12 col-md-6',
        key: "last_name",
        label: "Фамилия",
        type: "field",
        textType: "text",
      },
      {
        col: 'col-12 col-md-6',
        key: "father_name",
        label: "Отчество",
        type: "field",
        textType: "text",
      },
      {
        col: 'col-12 col-md-6',
        key: "first_name",
        label: "Имя",
        type: "field",
        textType: "text",
        readonly: false,
      },
      {
        col: 'col-12 col-md-6',
        key: "birthday",
        label: "Дата рождения",
        textType: "date",
        type: "field",
      },
      {
        col: 'col-12 col-md-12',
        label: "Роли пользователя",
        key: "roles",
        type: "selects",
        selectKey: "title",
        modal: "role",
        prefix: "role_t_r",
      },
      {
        col: 'col-12 col-md-12',
        label: "Должность",
        key: "position",
        type: "select",
        selectKey: "name",
        modal: "jobposition",
        // prefix: "jobposition_t_r",
      },
    ],
  }),
  props: ["id"],
  async created() {
    this.item = await this.cardContent(this.cardLink, this.id);
    delete this.item.position.pivot
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    setJobPosition: setJobPosition,
    pushLang: pushLang,
    async updateItem() {
      if(this.item.position)
        this.setJobPosition(this.item.id, this.item.position.id)
      let item = await this.cardUpdate(this.cardSetLink, this.item, this.fields);
    },
  },
};
</script>
<style></style>
